import { h, Component } from "preact";
import { route } from "preact-router";
import { Link } from "preact-router/match";
import { connect } from "react-redux";

import Page from "../../components/Page";
import Content from "../../components/Content";
import CountDown from "../../components/CountDown";
import BookingHeader from "../../components/BookingHeader";
import WarningMessage from "../../components/WarningMessage";
import YourOrder from "../../components/YourOrder";
import TwoCols from "../../components/TwoCols";
import GiftCardPageHeader from "../giftCards/GiftCardPageHeader";

import PaymentBPoint from "./PaymentBPoint";
import PaymentPayPal from "./PaymentPayPal";
import PaymentInvoice from "./PaymentInvoice";
import PaymentStripe from "./PaymentStripe";

import { getEvent } from "../../state/actions/eventActions";
import {
  getOrder,
  clearOrder,
  payByCreditDebit,
  payByInvoice,
  completeGiftCardOrder,
  CREDIT_AND_DEBIT,
  INVOICING
} from "../../state/actions/orderActions";
import { getGiftCardPage } from "../../state/actions/giftCardActions";
import { pageChange } from "../../utils/BrowserUtils";
import GiftCardCode from "../../components/GiftCardCode";

import ActionBar from "../../components/ActionBar";
import ActionButton from "../../components/ActionButton";

class PaymentWrapper extends Component {
  eventDidMount = () => {
    const { event, order, orderId, eventSlug, getEvent, getOrder } = this.props;
    if (!event.data && !event.loading) {
      getEvent(eventSlug, undefined, false, orderId, true);
    }
    pageChange("Payment");
  };
  globalDidMount = () => {
    const {
      order,
      orderId,
      getOrder,
      giftCards,
      eventSlug,
      getGiftCardPage
    } = this.props;
    if (!order.data && !order.loading) {
      getOrder(orderId);
    }
    if (!giftCards.giftCardPage && !giftCards.loading) {
      getGiftCardPage(eventSlug);
    }
  };

  determineIsGlobal = () => {
    return this.props.path
      ? this.props.path.indexOf("/gift-cards/") > -1
      : false;
  };
  render() {
    const isGlobal = this.determineIsGlobal();
    const { eventSlug } = this.props;
    return (
      <Payment
        {...this.props}
        isGlobal={isGlobal}
        didMount={isGlobal ? this.globalDidMount : this.eventDidMount}
        slug={eventSlug}
      />
    );
  }
}

class Payment extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    this.props.didMount();
  }

  render({
    orderId,
    slug,
    event,
    order,
    clearOrder,
    seatingMap,
    merchandise,
    isGlobal,
    giftCards,
    completeGiftCardOrder
  }) {
    if (order && order.orderGet.error) {
      return (
        <Page>
          <WarningMessage title="Order could not be loaded" />
        </Page>
      );
    }
    if (
      event.loading ||
      (!event.data && !isGlobal) ||
      (giftCards.loading && isGlobal) ||
      (!giftCards.giftCardPage && isGlobal) ||
      !order.data ||
      merchandise.merch.loading
    ) {
      return;
    }
    if (order && order.data.status === "complete") {
      clearOrder();
      route(`/${slug}`, true);
    }

    return (
      <div>
        {isGlobal ? <GiftCardPageHeader /> : null}
        <Page isGlobal={isGlobal}>
          <Content>
            <BookingHeader
              event={event}
              orderId={orderId}
              includeSeatingMap={seatingMap.seatingMapRequired}
              isGlobal={isGlobal}
            />
            <TwoCols>
              <div>
                <CountDown margin="0 0 24px 0" isGlobal={isGlobal} />
                <h2 class="sub-header">Payment</h2>
                <GiftCardCode />
                {order.paymentRequest.error ? (
                  <p class="text-error">{order.paymentRequest.error.message}</p>
                ) : (
                  ""
                )}
                {order.giftCardsRequest.isFullPayment ? (
                  <GiftCardSuccessMessage
                    order={order}
                    orderId={orderId}
                    completeGiftCardOrder={completeGiftCardOrder}
                  />
                ) : (
                  <PaymentMethod
                    event={event}
                    order={order}
                    orderId={orderId}
                    slug={slug}
                    isGlobal={isGlobal}
                  />
                )}
                <hr />
              </div>
              <YourOrder isGlobal={isGlobal} />
            </TwoCols>
          </Content>
        </Page>
      </div>
    );
  }
}

const GiftCardSuccessMessage = ({ orderId, completeGiftCardOrder, order }) => {
  return (
    <div>
      <div
        style={{
          borderRadius: 4,
          border: "solid 1px #dedede",
          padding: "16px 12px",
          textAlign: "center"
        }}
      >
        <h2>Successfully applied gift card!</h2>
      </div>
      <ActionBar>
        <ActionButton
          onClick={() => completeGiftCardOrder(orderId)}
          loading={order.giftCardsRequest.loading}
        >
          Complete
        </ActionButton>
      </ActionBar>
    </div>
  );
};

class Tabs extends Component {
  constructor() {
    super();
    this.checkChange = this.checkChange.bind(this);
  }
  checkChange(method) {
    const { order } = this.props;
    if (order.paymentRequest.loading) {
      return;
    }
    method();
  }
  render({ event, order, payByCreditDebit, payByInvoice, children }) {
    if (
      !order ||
      !event.data ||
      !event.data.paymentOptions.invoiceInfo ||
      !event.data.paymentOptions.invoiceInfo.enabled
    ) {
      return { children };
    }

    const creditClass =
      order.paymentMethod === CREDIT_AND_DEBIT ? "active" : "";
    const invoicingClass = order.paymentMethod === INVOICING ? "active" : "";
    return (
      <div>
        <h4>Payment Method</h4>
        <ul class="tab tab-block">
          <li class={`tab-item ${creditClass}`} style={{ minWidth: 180 }}>
            <a onClick={() => this.checkChange(payByCreditDebit)}>
              <span className="icon icon-credit-card" />
              Credit or debit Card
            </a>
          </li>
          <li class={`tab-item ${invoicingClass}`}>
            <a onClick={() => this.checkChange(payByInvoice)}>
              <span className="icon icon-invoice" />
              Invoice
            </a>
          </li>
        </ul>
        <div className="tab-content">{children}</div>
      </div>
    );
  }
}
Tabs = connect(
  state => ({ event: state.event, order: state.order }),
  { payByCreditDebit, payByInvoice }
)(Tabs);

const PaymentMethod = ({ event, order, orderId, slug, isGlobal }) => {
  if ((!isGlobal && !event.data) || order.timeExpired) {
    return null;
  }
  //for the moment, global orders just used bpoint
  if (isGlobal) {
    if (order.data.paymentGateway === "stripe-payments") {
      return (
        <Tabs>
          <PaymentStripe
            orderId={orderId}
            slug={slug}
            gateway={order.data.paymentGateway}
            isGlobal={isGlobal}
          />
        </Tabs>
      );
    } else {
      return (
        <Tabs>
          <PaymentBPoint orderId={orderId} slug={slug} isGlobal={isGlobal} />
        </Tabs>
      );
    }
  } else {
    if (order.paymentMethod === INVOICING) {
      return (
        <Tabs>
          <PaymentInvoice orderId={orderId} slug={slug} />
        </Tabs>
      );
    }

    if (
      event.data.paymentOptions &&
      event.data.paymentOptions.paymentId === "paypal"
    ) {
      return (
        <Tabs>
          <PaymentPayPal orderId={orderId} slug={slug} />
        </Tabs>
      );
    }
    if (
      event.data.paymentOptions &&
      (event.data.paymentOptions.paymentId === "stripe" ||
        event.data.paymentOptions.paymentId === "stripe-payments")
    ) {
      return (
        <Tabs>
          <PaymentStripe
            orderId={orderId}
            slug={slug}
            gateway={event.data.paymentOptions.paymentId}
          />
        </Tabs>
      );
    }
  }

  return (
    <Tabs>
      <PaymentBPoint orderId={orderId} slug={slug} />
    </Tabs>
  );
};

export default connect(
  state => ({
    event: state.event,
    order: state.order,
    merchandise: state.merchandise,
    seatingMap: state.seatingMap,
    giftCards: state.giftCards
  }),
  {
    getEvent,
    getOrder,
    clearOrder,
    payByCreditDebit,
    payByInvoice,
    getGiftCardPage,
    completeGiftCardOrder
  }
)(PaymentWrapper);



// WEBPACK FOOTER //
// ./routes/payment/Payment.js